import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import vueCountryRegionSelect from 'vue-country-region-select'
import LoadScript from 'vue-plugin-load-script'

Vue.use(LoadScript)
Vue.config.productionTip = false

Vue.use(vueCountryRegionSelect)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
